import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Cache } from 'aws-amplify';
import { UserSettingsHttpService } from '../../../../../core/user-settings';

@Component({
  selector: 'kt-machine-selection-dialog',
  templateUrl: './machine-selection-dialog.component.html',
  styleUrls: ['./machine-selection-dialog.component.scss']
})
export class MachineSelectionDialogComponent implements OnInit {

	selectedDisti = null;
	selectedMarket = null;
	selectedClient = null;
	selectedCampus = null;

	noDisti = false;
	noMarket = false;
	noClient = false;
	noCampus = false;

	distis ;
	markets ;
	clients ;
	campuses ;
	filteredDistis = [];
	filteredMarkets = [];
	filteredClients = [];
	filteredCampuses = [];

	distiSearchTerm = '';
	marketSearchTerm = '';
	clientSearchTerm = '';
	campusSearchTerm = '';

	user;
	role = null;
	showTill;

  constructor(public dialogRef: MatDialogRef<MachineSelectionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  	private userSettingshttp: UserSettingsHttpService) { }

  ngOnInit() {
	console.log(this.data);

	this.user = Cache.getItem('userAttr');
	this.role = this.user['custom:role'];
	if(this.data && this.data.show == 'disti'){
		this.getDistributors();
	} else if(this.data && this.data.show == 'market'){
		// Handle market selection - can be triggered by disti_id (data.id) or disti object (data.disti)
		if(this.data.disti && this.data.disti.disti_id){
			// Handle when disti object is passed directly
			this.selectedDisti = this.data.disti;
		} else if(this.data.id){
			if(!this.selectedDisti)
			this.selectedDisti = {};
			this.selectedDisti['disti_id'] = this.data.id;
		}
		if(this.selectedDisti && this.selectedDisti.disti_id){
			this.getMarkets();
		} else {
			// If no partner provided, show partner selection first
			this.getDistributors();
		}
	} else if(this.data && this.data.show == 'client'){
		// Handle client selection - can be triggered by disti_id (data.id) or market_id (data.market)
		if(this.data.disti && this.data.disti.disti_id){
			// Handle when disti object is passed directly
			this.selectedDisti = this.data.disti;
		} else if(this.data.id){
			if(!this.selectedDisti)
			this.selectedDisti = {};
			this.selectedDisti['disti_id'] = this.data.id;
		} else if(this.role === 'marketadmin') {
			// Explicitly set to null for market admin to avoid any interference
			this.selectedDisti = null;
		}
		if(this.data.market) {
			this.selectedMarket = this.data.market;
		} else if(this.role === 'marketadmin' && this.user['custom:market_id']){
			// For market admin, use their own market_id if not provided
			this.selectedMarket = {market_id: parseInt(this.user['custom:market_id'], 10)};
		}
		this.getClients();
	} else if(this.data && this.data.show == 'campus'){
		// Handle campus selection - can be triggered by client_id (data.id or data.client)
		if(this.data.client && this.data.client.client_id) {
			this.selectedClient = this.data.client;
		}
		if(this.data.market) {
			this.selectedMarket = this.data.market;
		} else if(this.role === 'marketadmin' && this.user['custom:market_id']){
			// For market admin, use their own market_id if not provided
			this.selectedMarket = {market_id: parseInt(this.user['custom:market_id'], 10)};
		}
		const params: any = {};
		if(this.data.id) {
			params.client_id = this.data.id;
		} else if(this.data.client && this.data.client.client_id) {
			params.client_id = this.data.client.client_id;
		}
		if(this.selectedMarket && this.selectedMarket.market_id) {
			params.market_id = this.selectedMarket.market_id;
		}
		this.getCampus(params);
	} else {
		this.getDistributors();
	}
  }

  getDistributors() {
	this.noDisti = false;
		if(this.role == 'sadmin') {
			this.userSettingshttp.getDistis()
			.subscribe((distis: any[]) => {
				this.distis = distis;
				if(distis.length){
					if(this.data.all)
					this.distis.unshift({name: "All", disti_id: null});
					this.filteredDistis = this.distis;
				}else{
					this.noDisti = true;
					this.filteredDistis = [];
				}
			});
		} else {
			console.log(this.user);
			this.distis = (this.user['custom:disti_id']).split(',');
			this.filteredDistis = this.distis;
		}
	}

getMarkets() {
	this.noMarket = false;
	const params = { disti_id: this.selectedDisti.disti_id };
	this.userSettingshttp.getMarkets(params)
	.subscribe((response: any) => {
		this.markets = response;
		if(this.markets && this.markets.length){
			if(this.data.all){
				this.markets.unshift({market_name: "All", market_id: null});
			}
			this.filteredMarkets = this.markets;
		}else{
			this.noMarket = true;
			this.filteredMarkets = [];
		}
	});
}

getClients() {
	this.noClient = false;
	const params: any = {};
	if (this.role.includes('admin')) {
		// Keep role scope restrictions for distributor and market admins.
		// Only super admin can bypass market scope in this dialog.
		if (this.role === 'sadmin') {
			params.ignore_market_scope = true;
		} else if (this.role === 'marketadmin' && this.selectedMarket && this.selectedMarket.market_id) {
			params.market_id = this.selectedMarket.market_id;
		} else {
			if(this.selectedDisti && this.selectedDisti.disti_id != null){
				params.disti_id = this.selectedDisti.disti_id;
			}
			if(this.selectedMarket && this.selectedMarket.market_id) {
				params.market_id = this.selectedMarket.market_id;
			}
		}
		this.userSettingshttp.getClients(params)
		.subscribe((clients: any[]) => {
			this.clients = clients;
			if(clients.length){
				if(this.data.all)
				this.clients.unshift({company_name: "All", client_id: null})
				this.filteredClients = this.clients;
			}else{
				this.noClient = true;
				this.filteredClients = [];
			}

		});
	} else {
		this.clients = (this.user['custom:client_id']).split(',');
		this.filteredClients = this.clients;
		this.getCampus({client_id: this.selectedClient.client_id});
	}
}

getCampus(params) {
	this.noCampus = false;
	const queryParams: any = {};
	if(params.client_id) {
		queryParams.client_id = params.client_id;
	}
	if(params.market_id) {
		queryParams.market_id = params.market_id;
	}
	if(this.selectedDisti && this.selectedDisti.disti_id) {
		queryParams.disti_id = this.selectedDisti.disti_id;
	}
	this.userSettingshttp.getCampus(queryParams)
	.subscribe((campuses: any[]) => {
		this.campuses = campuses;
		if(campuses.length){
			if(this.data.all)
			this.campuses.unshift({name: "All", campus_id: null});
			this.filteredCampuses = this.campuses;
		}else{
			this.noCampus = true;
			this.filteredCampuses = [];
		}
	});
}

  onDisti(obj){
	this.selectedDisti = obj;
	this.marketSearchTerm = '';
	this.clientSearchTerm = '';
	this.campusSearchTerm = '';
	this.filteredMarkets = this.markets || [];
	this.filteredClients = this.clients || [];
	this.filteredCampuses = this.campuses || [];
	if(this.data && this.data.showTill == 'disti'){
		this.dialogRef.close({success: true, data: {disti: this.selectedDisti}});
	} else if(obj.disti_id == null){
		// If distributor is 'All', skip market step and go to clients
		this.getClients();
	} else {
		this.getMarkets();
	}
  }

  onMarket(obj){
	this.selectedMarket = obj;
	this.clientSearchTerm = '';
	this.campusSearchTerm = '';
	this.filteredClients = this.clients || [];
	this.filteredCampuses = this.campuses || [];
	if(this.data && this.data.showTill == 'market'){
		this.dialogRef.close({success: true, data: {market: this.selectedMarket}});
	}else{
		this.getClients();
	}
  }

  onClient(obj){
	this.selectedClient = obj;
	this.campusSearchTerm = '';
	this.filteredCampuses = this.campuses || [];
	console.log(this.data.showTill,"this.data.showTill == 'client':",this.data.showTill == 'client');

	if(this.data && this.data.showTill == 'client'){
		this.dialogRef.close({success: true, data: {disti: this.selectedDisti, market: this.selectedMarket, client: this.selectedClient}});
	}else{
		const params: any = {client_id: this.selectedClient.client_id};
		if(this.selectedMarket && this.selectedMarket.market_id) {
			params.market_id = this.selectedMarket.market_id;
		}
		if(this.selectedDisti && this.selectedDisti.disti_id != null){
			params.disti_id = this.selectedDisti.disti_id;
		}
		this.getCampus(params);
	}

  }

  onCampus(obj){
	this.selectedCampus = obj;
	this.dialogRef.close({success: true, data: {disti: this.selectedDisti, market: this.selectedMarket, client: this.selectedClient, campus: this.selectedCampus}});
  }

  onBack(txt){
	if (txt == 'disti'){
		this.selectedCampus = null;
		this.selectedClient = null;
		this.selectedMarket = null;
		this.selectedDisti = null;
		this.distiSearchTerm = '';
		this.marketSearchTerm = '';
		this.clientSearchTerm = '';
		this.campusSearchTerm = '';
		this.filteredDistis = this.distis || [];
		this.filteredMarkets = this.markets || [];
		this.filteredClients = this.clients || [];
		this.filteredCampuses = this.campuses || [];
	} else if(txt == 'market') {
		this.selectedCampus = null;
		this.selectedClient = null;
		this.selectedMarket = null;
		this.marketSearchTerm = '';
		this.clientSearchTerm = '';
		this.campusSearchTerm = '';
		this.filteredMarkets = this.markets || [];
		this.filteredClients = this.clients || [];
		this.filteredCampuses = this.campuses || [];
	} else if(txt == 'client') {
		this.selectedCampus = null;
		this.selectedClient = null;
		this.clientSearchTerm = '';
		this.campusSearchTerm = '';
		this.filteredClients = this.clients || [];
		this.filteredCampuses = this.campuses || [];
	}
  }

  onDistiSearch(searchValue: string) {
	this.distiSearchTerm = searchValue;
	this.filteredDistis = this.filterBySearch(this.distis, this.distiSearchTerm, 'name');
  }

  onMarketSearch(searchValue: string) {
	this.marketSearchTerm = searchValue;
	this.filteredMarkets = this.filterBySearch(this.markets, this.marketSearchTerm, 'market_name');
  }

  onClientSearch(searchValue: string) {
	this.clientSearchTerm = searchValue;
	this.filteredClients = this.filterBySearch(this.clients, this.clientSearchTerm, 'company_name');
  }

  onCampusSearch(searchValue: string) {
	this.campusSearchTerm = searchValue;
	this.filteredCampuses = this.filterBySearch(this.campuses, this.campusSearchTerm, 'name');
  }

  private filterBySearch(items: any[], searchTerm: string, key: string): any[] {
	if(!items || !items.length) {
		return [];
	}
	const normalizedSearchTerm = this.normalizeSearchTerm(searchTerm);
	if(!normalizedSearchTerm) {
		return items;
	}
	return items.filter((item: any) =>
		this.normalizeSearchTerm(item && typeof item === 'object' ? item[key] : item).includes(normalizedSearchTerm)
	);
  }

  private normalizeSearchTerm(value: any): string {
	if(value == null) {
		return '';
	}
	return String(value).toLowerCase().trim();
  }

}
